import React from "react"
import Img from "gatsby-image"
import { getFluidGatsbyImage } from "gatsby-source-sanity"
import { makeStyles } from "@material-ui/core"

import clientConfig from "../../client-config"

export default ({ node }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const classes = useStyles()

  if (!node || !node.asset || !node.asset._id) {
    return null
  }
  const fluidProps = getFluidGatsbyImage(
    node.asset._id,
    { maxWidth: 1024 },
    clientConfig.sanity
  )
  return (
    <>
      <dialog open={isOpen} className={classes.dialog}>
        <button className={classes.close} onClick={() => setIsOpen(false)}>
          &times;
        </button>
        <Img
          fluid={fluidProps}
          style={{
            width: "min(90vw, 1024px)",
            marginTop: "3rem",
            maxHeight: "90vh",
          }}
        />
      </dialog>
      <figure className={classes.figure} onClick={() => setIsOpen(true)}>
        <Img fluid={fluidProps} alt={node.alt} />
        <figcaption style={{ textAlign: "center", fontSize: "0.5rem" }}>
          {node.caption}
        </figcaption>
      </figure>
    </>
  )
}

const useStyles = makeStyles(theme => ({
  figure: {
    width: "300px",
    display: "inline-block",
    cursor: "pointer",
    transition: "transform 0.3s ease-in-out",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  close: {
    fontSize: "3rem",
    cursor: "pointer",
    background: "none",
    color: theme.palette.primary.main,
    position: "absolute",
    top: "0.5rem",
    right: "0.5rem",
    lineHeight: 1,
    border: `solid 1px transparent`,
    "&:hover": {
      color: theme.palette.primary.dark,
      border: `solid 1px ${theme.palette.primary.dark}`,
      borderRadius: "1rem",
    },
  },
  dialog: {
    position: "fixed",
    inset: 0,
    zIndex: 1,
    paddingInline: "1rem",
    border: `solid 1px ${theme.palette.primary.main}`,
    borderRadius: "1rem",
    boxShadow: "0 0 0 1000px rgba(0,0,0,0.5)",
  },
}))
